<template>

  <div>
    <b-row>
      <b-col lg="8">
        <h2><a href="#" @click="goback"> Event record </a> > {{this.scenario.scenarioName}}</h2>
      </b-col>
      <b-col class="text-right">
        <h6><b> Last recording</b> <br>{{this.scenario.updatedDt | yyyyMMdd}}</h6>
      </b-col>
    </b-row>
    <p></p>
    <!-- <b-row class="text-right">
      <b-col>
        <b-button class="mb-1" variant="danger" squared style="width:150px" @click="deleteA">Delete scenario</b-button>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col>
        <div>
          <b-card>
            <ScenarioFlowchart2Vue v-if="onComplate" :scenario="scenario" @showChartDetail="showChartDetail"></ScenarioFlowchart2Vue>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <p></p>
    <b-row>
      <b-col>

        <b-card v-if="showGrid">
          <!-- <h5>
          Epcis Event List
        </h5> -->
          <b-skeleton-wrapper :loading="loading">
            <template #loading>
              <b-skeleton-table :rows="perPage" :columns="fields.length" :table-props="{ bordered: true, striped: true }" small>
              </b-skeleton-table>
            </template>
            <!-- style="margin-bottom: 0.5rem;" -->
            <b-table v-if="onComplate" striped id="my-table" :items="items" :per-page="perPage"
              :current-page="currentPage" :fields="fields" bordered hover responsive small
              caption-top> 
              <template #table-caption>연결되지 않은 이벤트 항목만 표출합니다.</template>
              <template v-slot:cell(no)="data">
                {{ (currentPage-1)*perPage + (data.index+1) }}
              </template>
            </b-table>
            <b-pagination align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" />
          </b-skeleton-wrapper>
        </b-card>
      </b-col>
    </b-row>
    <p></p>
    <b-row>
      <b-col>
        <div>
          <!-- <b-card> -->
          <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold text-primary" v-model="tabsActive">
            <b-tab v-for="(flow,idx) of this.scenario.scenarioEvents" :key="idx" :title="flow.label" @click="tabClick(flow)" lazy>
              <RecordingListDatailsTabVue :scenario="scenario" :flow=flow @OnSubmit="onSubmit"></RecordingListDatailsTabVue>
            </b-tab>
          </b-tabs>
          <!-- </b-card> -->
          <p></p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import hal from 'hateoas-hal-link-resolver'
import ScenarioFlowchart2Vue from '../../scenario/component/flowchart/ScenarioFlowchart2.vue';
import RecordingListDatailsTabVue from './RecordingListDatailsTab.vue';
import moment from 'moment';
export default {
  components: {
    // ScenarioFlowchart,
    ScenarioFlowchart2Vue,
    RecordingListDatailsTabVue
  },
  props: {
    // scenario: {
    //   scenarioName: ''
    // }
  },
  async beforeMount() {
    if (!this.$route.query.href) {
      alert('잘못된 호출입니다.')
      this.$router.go(-1);
    }

    await this._details();
    // console.log('dfjkslhfksdhfjksd')
    this.onComplate = true
    this.showFlow = this.scenario.scenarioEvents.length > 0;
    const productmap = this.productmap;
    this.scenario.products.forEach(product => {
      productmap[hal(product, 'self')] =  product;
    });
    const flow = this.scenario['scenarioEvents'][0];
    const location = await this.getBizLocation(this.scenario['scenarioEvents'][0]);
    await this.setEpcList(location, flow.bizStep);
  },
  data() {
    return {
      scenario: {
        // products:[],
        // facilities: []
      },
      fields: [
        { key: 'no', label: 'No.', class: 'text-center sortable' },
        { key: 'epcClass', label: 'Epc Class', class: 'text-center sortable' },
        { key: 'epcQuantity.productName', label: 'Product', class: 'text-center sortable' },
        { key: 'epcQuantity.lotNo', label: 'Lot No', class: 'text-center sortable' },
        { key: 'epcQuantity.quantity', label: 'Quantity', class: 'text-center' },
        { key: 'epcQuantity.uom', label: 'Uom'},
        { key: 'createdDt', label: 'Event Time', formatter:this.dateFormater },
      ],
      productmap: {},
      items: [],
      isHovered: false,
      loading: false,
      perPage: 5,
      currentPage: 1,
      onComplate: false,
      showFlow: false,
      emitFlow: null,
      tabsActive: 0,
      showGrid: false
    }
  },
  methods: {

    goback() {
      this.$router.go(-1);
    },
    async onSubmit(){
      console.log('xxxxxxxxxxxxxxxx  xxxxxxxxxxxxx  xxxxxxxxxxxxxxx xxxxxx')
      // this._details();
      const flow = this.scenario['scenarioEvents'][0];
      const location = await this.getBizLocation(this.scenario['scenarioEvents'][0]);
      await this.setEpcList(location, flow.bizStep);
    },
    async deleteA(event) {
      console.log(event);
      try {
        // await this.$http.delete(hal(this.scenario, 'self'));
        this.makeToast('success', '1건 삭제되었습니다.');
        // this.goback()
      } catch (err) {
        console.log(err);
        this.makeToastError(err);
      } finally {
        // this.goback()
      }
    },
    async _details() {
      try {
        const response = await this.$http.get(`${this.$route.query.href}`);
        this.scenario = response.data;
        this.scenario.organization = await this.$getOrganization();
        await this.setFlows();
        await this.setProduct();
        await this.setFacility();
      } catch (err) {
        console.log(err)
        alert(err);
        // this.$router.go(-1);
      }
    },

    async showChartDetail(flow){
      // this.tabsActive = 3;

      if(flow) {
        this.emitFlow = flow;
        const flows = this.scenario['scenarioEvents'];
        this.tabsActive = flows.findIndex(f => hal(f, 'self') == hal(flow, 'self'));
        const location = await this.getBizLocation(flows[this.tabsActive]);
        await this.setEpcList(location, flows[this.tabsActive].bizStep);
      }

    },

    async setProduct() {
      const response = await this.$http.get(hal(this.scenario, 'products'));
      this.scenario['products'] = this.$hateaos(response).product;
      this.products = this.scenario['products'];
    },
    async setFacility() {
      const response = await this.$http.get(hal(this.scenario, 'facilities'));
      this.scenario['facilities'] = this.$hateaos(response).facility;
    },
    async setFlows() {
      const response = await this.$http.get(hal(this.scenario, 'scenarioEvents'));
      this.scenario['scenarioEvents'] = this.$hateaos(response).events;
      // this.onComplate = true;
    },

    async setEpcList(location, bizStep) {
      this.loading = true;
      this.showGrid = true;
      const searchLink = `${hal(await this.$profile(), 'epcisWhat')}/search`;
      const searchApi = await this.$http.get(searchLink);
      const api = `${hal(searchApi.data, 'findByEpcisEventEpcisBizstepAndEpcisEventBizLocationAndEpcisEventParentEventListNull')}?epcisBizStepType=${bizStep}&bizLocation=${hal(location, 'self')}`;
      const epcisEventRes = await this.$http.get(api);
      this.items = this.$hateaos(epcisEventRes).epcisWhat;
      const epcisWhatList = this.$hateaos(epcisEventRes).epcisWhat;
      this.items = epcisWhatList.flatMap(what => {
        const epcQuantityList = what.epcQuantityList;
        what.epcList.forEach(epc => {
          epc.epcQuantity = epcQuantityList.find(epcQuantity => epcQuantity.epcRefFk == epc.quantityRefFk);
        });
        return what.epcList;
      })
      this.onComplate = true;
    },
    async getBizLocation(flow) {
      try {
        const response = await this.$http.get(hal(flow, 'bizLocation'));
        return response.data;
      } catch (err) {
        console.error(err);
      }
    },
    async reload() {
      console.log('refresh event???')
      this.onComplate = false;
      this.showFlow = true;
      await this.setFlows();
      this.onComplate = true;
    },

    makeToast(variant, message) {
      this.$bvToast.toast(message, {
        title: `200 OK`,
        variant: variant,
        solid: true
      })
    },
    makeToastError(err) {
      this.$bvToast.toast(err.message, {
        title: `Alert Request Failure`,
        variant: 'danger',
        solid: true,
        noAutoHide: true
      })
    },
    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval)
      this.$_loadingTimeInterval = null
    },
    dateFormater(val, record) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
    async tabClick(flow){
      const location = await this.getBizLocation(flow);
      await this.setEpcList(location, flow.bizStep);
    }    
    // items() {
    //   console.log('callllll!!!')
    //   this.loading = false;
    //   return [];
    // }
  },
  computed: {
    lastTabSho(){
      return this.emitFlow != null && this.scenario.scenarioEvents.find(event => event.hasCompleted == true) ? true : false;
    },
    rows() {
      return this.items.length
    },
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval()
        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loading = false;
            this.onComplate = true;
          }, 1000)
        }
      }
    },
  },
  // 커스텀 필터 설정
  filters: {
    // filter로 쓸 filter ID 지정
    yyyyMMdd: function (value) { //  yyyy MM dd 형태로 만들어줄거기 때문에 이렇게 이름을 지었음
      //console.log(value);
      if (value) {
        return new Date(value).format('yyyy-mm-dd hh:mi:ss');
      }
      return value;
    }
  }
}
</script>